import React from 'react'
import Modal from '../../modal'
import CloseSVG from '../../../../assets/svg/close.svg'
import ChooseFileSVG from '../../../../assets/svg/choose-file.svg'
import { useGetTrainingResult } from '../../../../redux/employees/hook/training'
import { useState } from 'react'
import {
  PAGINATION_DEFAULT,
  resultStatusConfig,
} from '../../../../utils/constants'
import DataTable from '../../../datatable'

const ViewTrainingResults = ({ isOpen, closeModal, trainingData }) => {
  const openInNewTab = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    statusFilter: PAGINATION_DEFAULT.statusFilter,
    search: '',
    grade: '',
  })
  const { data: results } = useGetTrainingResult(
    trainingData?.id,
    pagination?.limit,
    pagination?.page,
    pagination?.statusFilter,
    pagination?.search
  )

  const tableConfig = {
    headers: ['Employee Name', 'Grade', 'Status'],
    keys: ['employeeName', 'score', 'status'],
    mobileHeader: {
      left: {
        title: 'Employee Name',
        key: 'employeeName',
      },
      right: {
        title: 'Status',
        key: 'status',
      },
    },
  }

  return (
    <>
      <Modal
        scrollable={true}
        className='!max-w-[600px] !rounded-none'
        isOpen={isOpen}
        centered={true}
      >
        <div className='flex flex-col overflow-auto'>
          <div className='px-4 pt-2'>
            <div className='flex justify-between items-center'>
              <span className='header-4'>View Training Results</span>
              <div className='cursor-pointer' onClick={() => closeModal()}>
                <img src={CloseSVG} alt='close' />
              </div>
            </div>
          </div>
          <hr className='divider mb-2' />
          <div className='flex flex-col gap-3 mx-4'>
            <div className='flex flex-col'>
              <span className='text-[12px] text-[#78787d]'>Module Title</span>
              <span className='text-sm font-bold'>
                {trainingData.module_name}
              </span>
            </div>
            <div className='flex flex-col'>
              <span className='text-[12px] text-[#78787d]'>
                Module Description
              </span>
              <span className='text-sm font-bold'>
                {trainingData.module_description}
              </span>
            </div>
            <div className='flex flex-col gap-1'>
              <p className='text-xs text-color-gray'>Document</p>
              <div
                onClick={() => openInNewTab(trainingData.module_doc)}
                className='flex items-center justify-center rounded-md p-2 gap-2 w-[150px] bg-hr-primary-1 cursor-pointer'
              >
                <img src={ChooseFileSVG} alt='file' />
                <p className='text-xs text-white'>Download</p>
              </div>
            </div>
            <p className='font-medium'>Passing Criteria Settings</p>
            <div className='flex flex-wrap gap-3 items-center'>
              <div className='flex flex-col gap-1'>
                <p className='text-xs text-color-gray'>Question Count</p>
                <p className='text-sm bg-highlight rounded-md flex items-center justify-center p-2 w-[150px] border'>
                  {trainingData?.questions?.length}
                </p>
              </div>
              <div className='flex flex-col gap-1'>
                <p className='text-xs text-color-gray'>Passing Grade</p>
                <p className='text-sm bg-highlight rounded-md flex items-center justify-center p-2 w-[150px] border'>
                  {trainingData?.passing_grade}
                </p>
              </div>
              <div className='flex flex-col gap-1'>
                <p className='text-xs text-color-gray'>Retry Limit</p>
                <p className='text-sm bg-highlight rounded-md flex items-center justify-center p-2 w-[150px] border'>
                  {trainingData?.retry_limit}
                </p>
              </div>
              <div className='flex flex-col gap-1'>
                <p className='text-xs text-color-gray'>Deadline </p>
                <p className='text-sm bg-highlight rounded-md flex items-center justify-center p-2 w-[150px] border'>
                  12/12/2025
                </p>
              </div>
              <div className='pb-5 flex flex-col gap-2 w-full'>
                <>
                  <h2 className='text-base font-semibold '>Results</h2>
                  <p className='text-sm text-color-gray'>
                    The grade's are displayed from the top grade to the least grade.
                  </p>
                </>
                <div className='flex flex-col h-full mb-5 overflow-y-auto'>
                  <DataTable
                    data={results}
                    tableConfig={tableConfig}
                    statusConfig={resultStatusConfig}
                    updatePagination={(data) => setPagination(data)}
                    filterByStatus={true}
                    layoutSwitch={false}
                    searchData={true}
                    noCheck={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default ViewTrainingResults
